import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px text-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}, " Layout ", -1)
const _hoisted_4 = {
  class: "\n          menu\n          menu-sub\n          menu-sub-dropdown\n          menu-column\n          menu-rounded\n          menu-gray-600\n          menu-state-bg-light-primary\n          fw-bold\n          py-4\n          fs-6\n          w-275px\n        ",
  "data-kt-menu": "true"
}
const _hoisted_5 = { class: "form-check form-check-custom" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label text-primary",
  for: "flexSwitchChecked"
}, " Dark Mode ", -1)
const _hoisted_7 = { class: "d-flex align-items-center ms-1 ms-lg-3" }
const _hoisted_8 = { class: "d-flex align-items-center ms-1 ms-lg-3 text-primary" }
const _hoisted_9 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_10 = {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px text-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_11 = {
  class: "d-flex align-items-center d-lg-none ms-2 me-n3",
  title: "Show header menu"
}
const _hoisted_12 = {
  class: "btn btn-icon btn-active-light-primary",
  id: "kt_header_menu_mobile_toggle"
}
const _hoisted_13 = { class: "svg-icon svg-icon-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.config.content.darkMode = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggle($event)))
          }, null, 544), [
            [_vModelCheckbox, _ctx.config.content.darkMode]
          ]),
          _hoisted_6
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_select, {
        modelValue: _ctx.selectedClients,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedClients = $event)),
        placeholder: "...select customer...",
        class: "w-100",
        filterable: "",
        onChange: _ctx.handleClientChange
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientList, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.key,
              label: item.name,
              value: item.key
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_8, " | Account Name: " + _toDisplayString(this.accountname) + " | ", 1),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.mailid), 1),
      _createVNode(_component_KTUserMenu)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/text/txt001.svg" })
        ])
      ])
    ])
  ]))
}